import storage from '../services/storage/storage';

export default function getAuthToken() {
  return storage.local.getItem('auth_token');
}
